import { get, ref } from 'firebase/database'
import { z } from 'zod'

import { getFirebaseServices } from '../../services/firebase'

const userRecordSchema = z
  .object({
    branches: z.record(z.string(), z.string()).optional().default({}),
  })
  .passthrough()

export type Branch = {
  id: string
  name: string
}

export type TenantRepository = {
  getBranches: (callerUid: string) => Promise<Branch[]>
  hasCallerClinic?: (callerUid: string) => Promise<boolean>
}

export const firebaseTenantRepository: TenantRepository = {
  async hasCallerClinic(callerUid) {
    const snapshot = await get(
      ref(getFirebaseServices().database, `clinic/${callerUid}/settings`)
    )
    return snapshot.exists()
  },

  async getBranches(callerUid) {
    const snapshot = await get(
      ref(getFirebaseServices().database, `Users/${callerUid}`)
    )
    if (!snapshot.exists()) return []

    const record = userRecordSchema.parse(snapshot.val())
    return Object.entries(record.branches).map(([id, name]) => ({ id, name }))
  },
}
